import React from "react";
import { Input } from "reactstrap";
export default class SearchableDropdown extends React.Component {
  state = {
    showContent: false
  };
  componentDidMount() {
    // add event listener for clicks
    document.addEventListener('click', this.handleClickAway, false);
  }

  componentWillUnmount() {
    // make sure you remove the listener when the component is destroyed
    document.removeEventListener('click', this.handleClickAway, false);
  }

  handleClickAway = e => {
    if(this.node.contains(e.target))
    {
    return;
    }
    else {
      this.setState({ showContent: false });

    }
  };
  render() {
    const { showToolTip } = this.state;
    const { index,value } = this.props;
    return (
      <React.Fragment>
        <div className="dropdown-input" ref={node => this.node = node}>
          <Input
            onClick={() => this.setState({ showContent: true })}
            placeholder={this.props.placeholder}
            disabled={this.props.isDisabled}
            value={this.props.value}
          />
          <div
            className={`dropdown-content ${this.state.showContent && "show"}`}
          >
            {this.props.children}
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorUIComponents/SearchableDropdown.js